import React from "react";
import { connect } from "react-redux";
import {
  getArticles,
  satArticle,
  pushArticle,
  removeArticle
} from "../../actions/sub";
import {
  Container,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Button,
  UncontrolledAlert
} from "reactstrap";
import qs from "query-string";
import ReactBSAlert from "react-bootstrap-sweetalert";
import ArticleTable from "../../components/sub/ArticleTable";
import PaginationBar from "../../components/Commons/PaginationBar";

class SubPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      per_page: 7,
      alert: "",
      openUserModal: false,
      selectedUser: {},
      activeCategoryType: null,
      articles: []
    };
    this.goToPage = this.goToPage.bind(this);
    this.pushArticle = this.pushArticle.bind(this);
    this.removeArticle = this.removeArticle.bind(this);
  }

  componentDidMount() {
    let urlParams = qs.parse(this.props.search);

    this.setState({
      ...this.state,
      ...urlParams
    });
    this.getArticles({ ...urlParams });
    this.props.satArticle();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.location !== this.props.location) {
      let urlParams = qs.parse(newProps.search);
      this.getArticles(urlParams);
    }
  }

  getArticles(params) {
    // let urlParams = qs.parse(this.props.search);
    let searchParams = {
      // ...urlParams,
      ...params
    };
    this.props.getArticles(searchParams);
  }

  goToPage(page) {
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      page
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  filterCat(category_id) {
    const activeCategoryType = this.getCurrentCategory(category_id);
    this.setState({
      activeCategoryType: activeCategoryType
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      category_id
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  pushArticle() {
    this.props.pushArticle();
  }

  confirmedRemove(row) {
    this.setState({
      alert: ""
    });
    console.log(row);
    this.props.removeArticle(row.id);
  }

  removeArticle(row) {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          title={`从列表中移除 ${row.title}?`}
          style={{ backgroundColor: "#ffffff" }}
          onCancel={() => this.hideAlert()}
          onConfirm={() => this.confirmedRemove(row)}
          showCancel
          cancelBtnBsStyle="default"
          cancelBtnText="取消"
          confirmBtnBsStyle="primary"
          confirmBtnText="是的，刪除！"
          btnSize=""
        >
          <small>刪除操作將無法取消</small>
        </ReactBSAlert>
      )
    });
  }

  render() {
    const {
      articles,
      articlesPagination,
      getArticlesRequest,
      sub_data,
      errorMsg,
      successBackMsg
    } = this.props.sub;
    console.log(sub_data);
    let pushable_categories = sub_data
      ? sub_data.pushable_categories
        ? sub_data.pushable_categories
        : []
      : [];

    const heads = ["分類", "標題", "操作"];
    const dataAttributes = ["position", "title", "contact", "phone", "email"];

    return (
      <Container className="mt-4" fluid>
        {this.state.alert}
        {errorMsg && (
          <UncontrolledAlert color="danger" fade={false}>
            <span className="alert-inner--text mb-4">{errorMsg}</span>
          </UncontrolledAlert>
        )}
        {successBackMsg && (
          <UncontrolledAlert color="success" fade={false}>
            <span className="alert-inner--text mb-4">{successBackMsg}</span>
          </UncontrolledAlert>
        )}
        <div className="row">
          <div className="col-lg-8">
            <Card className="card-frame">
              <CardHeader className="border-0">
                <div className="d-flex align-items-center justify-content-between"></div>
                <div className="d-flex align-items-center justify-content-between"></div>
              </CardHeader>
              <ArticleTable
                heads={heads}
                dataAttributes={dataAttributes}
                rows={articles}
                loading={getArticlesRequest}
                remove={this.removeArticle}
              />
              <CardFooter className="py-4 d-flex justify-content-center">
                {articlesPagination.currentPage ? (
                  <PaginationBar
                    currentPage={articlesPagination.currentPage}
                    totalPages={articlesPagination.lastPage}
                    pageNeighbours={1}
                    goToPage={page => this.goToPage(page)}
                  />
                ) : null}
              </CardFooter>
            </Card>
          </div>
          <div className="col-lg-4">
            <Card className="card-frame">
              <CardHeader className="border-0">
                <div className="d-flex align-items-center justify-content-between">
                  <div>分類</div>
                  <div>數量</div>
                </div>
              </CardHeader>
              <CardBody>
                {pushable_categories.map((val, key) => (
                  <div
                    className="d-flex align-items-center justify-content-between"
                    key={`cat-${key}`}
                  >
                    <div>{val.display_name}</div>
                    <div>X {val.counts}</div>
                  </div>
                ))}
              </CardBody>

              <CardFooter className="py-4 d-flex justify-content-center">
                <Button
                  color="default"
                  type="button"
                  disabled={this.props.sub.editArticleRequest}
                  onClick={this.pushArticle}
                >
                  一鍵推送
                </Button>
              </CardFooter>
            </Card>
          </div>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    sub: state.sub,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getArticles: params => dispatch(getArticles(params)),
    satArticle: params => dispatch(satArticle(params)),
    pushArticle: params => dispatch(pushArticle(params)),
    removeArticle: params => dispatch(removeArticle(params))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubPage);
